import { observer } from 'mobx-react';
import Toolbar from '@mui/material/Toolbar';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import { makeStyles } from '@mui/styles';
import { storeKrunica } from '../store/KrunicaStore';

const useStyles = makeStyles((theme) => ({
  menu: {
    color: 'transparent',
    width: '100%',
    height: '50px',
    margin: '0',
    paddingLeft: '0',
    zIndex: '6',
    justifyContent: 'space-around',
    backgroundColor: '#FFE100',
    paddingRight: '0',
    padding: '0',
    overflowX: 'hidden',
    [theme.breakpoints.up('sm')]: {
      backgroundColor: '#e9e9e9',
      color: '#555',
      border: '1px solid #ece7e7',
      width: '68%',
      margin: 'auto',
    },
  },
}));

export default observer(function Menu() {
  const classes = useStyles();
  const {
    promjeniJezik,
    trenutniJezik,
    trenutnaKrunica,
    promjeniKrunicu,
    getlistaJezika,
    getlistaKrunica,
    getnazivdanTjedan,
    promjeniDanUTjednu,
    aktivniDan,
    aktivnaZemlja,
  } = storeKrunica;
  const { krunice } = aktivnaZemlja;

  // Tab vrijednost u Browseru
  document.title = krunice.find((k) => k.value === trenutnaKrunica)?.label;
  // console.log('Menu', getlistaKrunica);

  return (
    <div className={classes.menu}>
      <Toolbar variant="dense" style={{ marginLeft: '0' }}>
        <TextField
          sx={{
            '& .MuiSelect-select': {
              fontSize: 12,
            },
          }}
          fullWidth
          select
          size="small"
          inputProps={{ MenuProps: { disableScrollLock: true } }}
          id="krunica"
          value={trenutnaKrunica}
          onChange={(e) => promjeniKrunicu(e)}
        >
          {getlistaKrunica.map((option) => {
            return (
              <MenuItem
                key={option.value}
                value={option.value}
                sx={{ fontSize: 20 }}
              >
                {option.label}
              </MenuItem>
            );
          })}
        </TextField>
        <TextField
          sx={{
            width: 120,
            '& .MuiSelect-select': {
              fontSize: 14,
            },
          }}
          select
          size="small"
          inputProps={{ MenuProps: { disableScrollLock: true } }}
          id="jezik"
          value={trenutniJezik}
          onChange={(e) => promjeniJezik(e)}
        >
          {getlistaJezika.map((option) => (
            <MenuItem
              key={option.value}
              value={option.value}
              style={{ fontSize: 20 }}
            >
              {option.label}
            </MenuItem>
          ))}
        </TextField>
        <TextField
          disabled={trenutnaKrunica !== 'gospa'}
          sx={{
            width: 135,
            '& .MuiSelect-select': {
              fontSize: 14,
            },
          }}
          select
          size="small"
          inputProps={{ MenuProps: { disableScrollLock: true } }}
          id="danTjedan"
          value={aktivniDan}
          onChange={(e) => promjeniDanUTjednu(e)}
        >
          {getnazivdanTjedan.map((dan) => (
            <MenuItem
              key={dan.value}
              value={dan.value}
              style={{ fontSize: 20 }}
            >
              {dan.label}
            </MenuItem>
          ))}
        </TextField>
      </Toolbar>
    </div>
  );
});
